import { useRouter } from 'next/router';
import useFetch from '@hooks/useFetch';

const useEduLeaderboard = () => {
  const { query } = useRouter();

  const { data, isValidating, isError, mutate } = useFetch(
    `pariksha/v1/practice/educator_leaderboard/?goal_uid=${query.goalUID}`
  );

  return {
    data,
    isValidating,
    isError,
    mutate
  };
};

export default useEduLeaderboard;
